module.exports = __webpack_public_path__ + "static/ourStoryImg.67dc3ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStoryImg.png
// module id = 225
// module chunks = 21571696733600 278046050153039